<template>
  <svg
      :width="width"
      :height="height"
      id="arrow"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19.076 16.36"
      :style="transformStyle"
  >
    <g id="Group_41" data-name="Group 41" transform="translate(0 0)">
      <path
          id="Path_61"
          class="arrow-path"
          data-name="Path 61"
          d="M17.929,38.682a1.364,1.364,0,0,0-.236-.017H4.235l.293-.136a2.73,2.73,0,0,0,.771-.546l3.774-3.774a1.413,1.413,0,0,0,.2-1.808,1.365,1.365,0,0,0-2.047-.177L.4,39.047a1.365,1.365,0,0,0,0,1.93h0L7.224,47.8a1.365,1.365,0,0,0,2.047-.136,1.413,1.413,0,0,0-.2-1.808L5.307,42.077a2.73,2.73,0,0,0-.682-.5l-.409-.184h13.4a1.413,1.413,0,0,0,1.44-1.146A1.365,1.365,0,0,0,17.929,38.682Z"
          transform="translate(0 -31.842)"
          :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ArrowIcon',
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 19,
    },
    height: {
      type: [Number, String],
      default: 16,
    },
    direction: {
      type: String,
      default: 'right', // 'right', 'left', 'up', 'down'
      validator: (value) => ['right', 'left', 'up', 'down'].includes(value)
    }
  },
  computed: {
    transformStyle() {
      const rotations = {
        right: 'rotate(0)',
        left: 'rotate(180deg)',
        up: 'rotate(-90deg)',
        down: 'rotate(90deg)'
      };
      return {
        transform: rotations[this.direction],
        transformOrigin: 'center'
      };
    }
  }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
  transition: transform 0.2s ease;
}
</style>